import React from 'react'

import style from './Username.module.scss'
import { over1400 } from '~css/breakpoints.module.scss'

const Username = ({ 
  explorer
}) => (
  <>
    { explorer.accessToken.loggedIn() && (
      <span className={[style.username, over1400].join(' ')}>
        {explorer.accessToken.username()}
      </span>
    )}
  </>
)

export default Username
